<!-- A generic tree item which can be used to display n-level trees -->
<!--    Each item should have an array named 'children' for the decendent level   -->
<!--    If there is no 'item' slot, the control looks for a 'name' to render the text for the tree item. -->
<script lang="ts" setup>
    import { computed, onMounted } from 'vue';
    import { TreeItemModel, SimpleTreeItemModel } from '../lib/Models/TreeItemModel';

    const emit=defineEmits(["close-vue-modal-iframe", "onItemClick"]);


    const props = defineProps<{
        treeItem: SimpleTreeItemModel | TreeItemModel<any>
    }>();

    onMounted(() =>{
        if (props.treeItem.children)
        {
            // Make sure the child items point to the parent
            for(const child of props.treeItem.children)
                child.parent = props.treeItem;
        }
    });
    
    const hasNameProperty = computed(() => {
        if (typeof(undefined) === typeof(props.treeItem?.name))
            return false;
        return true;
    });

    function toggleTreeItem(treeItem: any) {
        if (!treeItem.showChildItems)
            treeItem.showChildItems = true;
        else
            treeItem.showChildItems = false;
    }

    function hasChildren(treeItem: any) {
        return treeItem?.children?.length > 0;
    }

    function onItemClick(treeItem: any){
        emit('onItemClick', treeItem);
    }

    function toggleIconClass(treeItem: any): string {
        return "TreeItemToggle fa-solid " + (treeItem.showChildItems ? "fa-chevron-down" : "fa-chevron-right");
    }
</script>

<style scoped>
    .ActionCursor { cursor: pointer; }
    .RootTreeItem { padding-top: 0.25em }

    .ChildTreeItem { margin-left: 1em; padding-top: 0.25em; }
    .IndentChildTreeItem { margin-left: 2em; padding-top: 0.25em; }
    .ChildTreeItemWithNoChildren { width: .5em; display: inline-block; }

    .TreeItemToggle 
    { 
        cursor: pointer;
        margin-right: 0.33em; 
        color: dimgrey; 
    }
    .TreeItemToggle:hover { color: black; text-shadow: 0 0 5px lawngreen, 0 0 10px lawngreen, 0 0 20px lawngreen, 0 0 40px lawngreen; }

    .TreeItemDiv {display: inline-block; }
</style>

<template>
    <div class="ChildTreeItem">
        <div class="TreeItemDiv" style="width:1em">
            <i v-if="hasChildren(treeItem)"
                :class="toggleIconClass(treeItem)"
                aria-hidden="true"
                @click="toggleTreeItem(treeItem)"></i>
            <i v-else
                class="ChildTreeItemWithNoChildren"
                aria-hidden="true"></i>
        </div>

        <div @click="onItemClick(treeItem)" class="ActionCursor TreeItemDiv">
            <slot name="item" :treeItem="treeItem">
                <!-- Check if the data has a 'name' property if we were not provided with a slot -->
                <span v-if="hasNameProperty">
                    {{treeItem?.name}}
                </span>
                <span v-else style="color:red">
                    <div v-if="typeof(undefined) === typeof(treeItem)">
                        treeItem is undefined
                    </div>
                    <div v-else>
                        missing treeItem slot placeholder. 'treeItem': ({{treeItem}})
                    </div>
                </span>
            </slot>
        </div>

        <div v-if="treeItem?.showChildItems">
            <div v-for="childTreeItem in treeItem.children">
                <TreeItem :treeItem="childTreeItem" @click="onItemClick(childTreeItem)">
                    <template v-for="(_, name) in $slots" v-slot:[name]="slotData">
                        <slot :name="name" v-bind="slotData" />
                    </template>
                </TreeItem>
            </div>
        </div>     
    </div>
</template>